import React from 'react';
import { Grid, Form } from 'semantic-ui-react';

export const RenovacionSection = React.memo(({
  formik,
  disabled = false
}) => {
  return (
    <>
      <Grid.Column computer={2} mobile={16} tablet={16}>
        <h5>Renovación</h5>
        <Form.Group inline>
          <Form.Radio
            disabled={disabled}
            value={true}
            checked={formik.values.clinica_renovacion}
            label="Si"
            name="clinica_renovacion"
            onClick={() => formik.setFieldValue("clinica_renovacion", true)}
          />
          <Form.Radio
            disabled={disabled}
            value={false}
            checked={!formik.values.clinica_renovacion}
            label="No"
            name="clinica_renovacion"
            onClick={() => {
              formik.setFieldValue("clinica_renovacion", false);
              formik.setFieldValue("clinica_renovacion_frecuencia", null);
              formik.setFieldValue("clinica_renovacion_fecha", null);
            }}
          />
        </Form.Group>
      </Grid.Column>
      <Grid.Column computer={3} mobile={16} tablet={16}>
        <h5>A partir de</h5>
        <Form.Input
          disabled={disabled || !formik.values.clinica_renovacion}
          name="clinica_ultima_renovacion"
          fluid
          type="date"
          value={
            formik.values.clinica_ultima_renovacion ||
            new Date().toISOString().slice(0, 10)
          }
          onChange={(_, data) => {
            formik.setFieldValue("clinica_ultima_renovacion", data.value);
            if (data.value && formik.values.clinica_renovacion_frecuencia) {
              let fecha = new Date(data.value);
              fecha.setMonth(
                fecha.getMonth() +
                  parseInt(formik.values.clinica_renovacion_frecuencia, 10)
              );
              formik.setFieldValue(
                "clinica_renovacion_fecha",
                fecha.toISOString().slice(0, 10)
              );
            }
          }}
        />
      </Grid.Column>
      <Grid.Column computer={3} mobile={16} tablet={16}>
        <h5>Frecuencia de renovación</h5>
        <Form.Input
          disabled={disabled || !formik.values.clinica_renovacion}
          name="clinica_renovacion_frecuencia"
          fluid
          type="number"
          min={1}
          placeholder="Meses"
          value={formik.values.clinica_renovacion_frecuencia}
          onChange={(_, data) => {
            formik.setFieldValue(
              "clinica_renovacion_frecuencia",
              data.value
            );
            if (formik.values.clinica_ultima_renovacion && data.value) {
              let fecha = new Date(formik.values.clinica_ultima_renovacion);
              fecha.setMonth(fecha.getMonth() + parseInt(data.value, 10));
              formik.setFieldValue(
                "clinica_renovacion_fecha",
                fecha.toISOString().slice(0, 10)
              );
            }
          }}
        />
      </Grid.Column>
      <Grid.Column computer={5} mobile={16} tablet={16}>
        <h5>Próxima renovación</h5>
        <Form.Input
          disabled={true}
          name="clinica_renovacion_fecha"
          fluid
          value={formik.values.clinica_renovacion_fecha}
        />
      </Grid.Column>
    </>
  );
});

